import axios from "axios";
import Config from "../../utils/Config";

class DealsService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("dbx_aff_tkn")}`,
      },
    };
  }

  async getTrendingDeals(numberOfDeals = 8) {
    try {
      const response = await axios.get(
        `${Config.devBackendDomain}promoted/deals/${numberOfDeals}`,
        {
          headers: this.getHeaders(),
        }
      );
      return {
        status: true,
        message:
          response?.data?.data?.reason || "Trending deals fetched successfully",
        data: response?.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.reason || "Something went wrong",
        data: null,
      };
    }
  }

  async getDealDetails(deal_slug) {
    try {
      const response = await axios.get(
        `${Config.devBackendDomain}deal/show/${deal_slug}`,
        this.getHeaders()
      );
      return {
        status: true,
        message:
          response?.data?.data?.reason || "Deal details fetched successfully",
        data: response?.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.reason || "Something went wrong",
        data: null,
      };
    }
  }

  async getAllDeals() {
    try {
      const response = await axios.get(
        `${Config.devBackendDomain}deals`,
        this.getHeaders()
      );
      return {
        status: true,
        message:
          response?.data?.data?.reason || "All deals fetched successfully",
        data: response?.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.reason || "Something went wrong",
        data: null,
      };
    }
  }

  async getFashionDeals() {
    try {
      const fashionQuery = "Fashion & Accessories";
      const response = await axios.get(
        `${Config.devBackendDomain}category/deals/${fashionQuery}/8`,
        this.getHeaders()
      );
      return {
        status: true,
        message:
          response?.data?.data?.reason || "Fashion deals fetched successfully",
        data: response?.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error?.response?.data?.reason || "Something went wrong",
        data: null,
      };
    }
  }
  
}
const dealsService = new DealsService();
export default dealsService;
